import * as React from 'react';
import { connect } from 'react-redux';
import UtilityService from '../../services/UtilityService';
import SignalRService from '../../signalRController';

class UpdateInventoryPrices extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            message: ""
        };

        this.triggerUpdatePrices = this.triggerUpdatePrices.bind(this);
    }

    private emptyState() {
        return {
            message: ""
        };
    }

    triggerUpdatePrices = async () => {
        this.setState({ message: "Update inventory prices triggered!" });
        await UtilityService.updateInventoryPrices();
    }

    componentDidMount = () => {
        SignalRService.registerReceiveEvent("UpdateInventoryPrices",
            (msg) => {
                this.setState({ message: msg.Message });
            }
        );
    }

    componentWillUnmount() {
        SignalRService.unRegisterReceiveEvent("UpdateInventoryPrices");
    }

    public render() {
        const { message } = this.state;
        return (
            <React.Fragment>
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12">
                            <button className="btn" onClick={this.triggerUpdatePrices}>Update Inventory Prices</button> {message}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
};

export default connect()(UpdateInventoryPrices);
